module.exports = __webpack_public_path__ + "static/media/ic-tools.941da0ae.svg";